import React, { Fragment } from "react";
import Layout from "../../layouts/Layout";
import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
import { WEBSITE_NAME } from "../../constants/CompanyConstants";
import {
  META_BIOLOGISCH_CERTIFICATEN_DESCRIPTION,
  META_BIOLOGISCH_CERTIFICATEN_TITLE,
} from "../../constants/MetaTagsConstants";
import { Helmet } from "react-helmet";
import { BreadcrumbStructuredData } from "../../components/structured-data/BreadcrumbStructuredData";
import {
  BREADCRUMB_BIOLOGICAL_CERTIFICATES,
  BREADCRUMB_HOME,
} from "../../constants/BreadcrumbConstants";
import styled from "styled-components";

const { Panel } = Collapse;

const BiologicalCertificates = () => {
  const { t, i18n } = useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>
          {META_BIOLOGISCH_CERTIFICATEN_TITLE} · {WEBSITE_NAME}
        </title>
        <meta
          name="description"
          content={META_BIOLOGISCH_CERTIFICATEN_DESCRIPTION}
        />
        {BreadcrumbStructuredData([
          BREADCRUMB_HOME,
          BREADCRUMB_BIOLOGICAL_CERTIFICATES,
        ])}
      </Helmet>
      <Layout headerTop="visible">
        <div className="section-area">
          <div className="container">
            <div className="py-4">
              <h1>{t("biological_certificates_title")}</h1>
              <span>{t("biological_certificates_description")}</span>
            </div>
            <div className="py-4">
              <StyledCollapse>
                <Panel header="SKAL" key="1">
                  <img
                    src={"/assets/img/certificates/skal-bio.png"}
                    alt={"Stichting SKAL Biocontrole Certificaat"}
                  />
                </Panel>
                <Panel header="Van der Laan" key="3">
                  <img
                    src={"/assets/img/certificates/vanderlaan-bio.png"}
                    alt={"World Halal Food Council Halal Certificaat"}
                  />
                </Panel>
                <Panel header="Irish Organic Association" key="4">
                  <img
                    src={"/assets/img/certificates/ioa-bio.png"}
                    alt={"Irish Organic Association"}
                  />
                </Panel>
              </StyledCollapse>
            </div>
          </div>
        </div>
      </Layout>
    </Fragment>
  );
};

const StyledCollapse = styled(Collapse)`
  img {
    width: 100%;
  }
`;

export default BiologicalCertificates;
